import { Activity, AlertTriangle, Lightbulb, Megaphone, TrendingUp } from 'lucide-react';
import { EmptyState } from '../../components/EmptyState';
import { Card } from '../../components/ui/Card';
import { PageHeader } from '../../components/ui/PageHeader';

const centerSections = [
  {
    title: 'Rekomendacje',
    icon: Lightbulb,
    emptyTitle: 'Brak rekomendacji',
    description: 'Rekomendacje pojawią się po uruchomieniu źródeł danych Marketingu.',
  },
  {
    title: 'Braki do uzupełnienia',
    icon: AlertTriangle,
    emptyTitle: 'Brak wykrytych blokad',
    description: 'Tutaj zobaczysz brakujące zgody, domeny, claims, dowody i oferty.',
  },
  {
    title: 'Wyniki',
    icon: TrendingUp,
    emptyTitle: 'Brak wyników',
    description: 'Wyniki wysyłek pojawią się po publikacji pierwszej automatyzacji email.',
  },
  {
    title: 'Ostatnia aktywność',
    icon: Activity,
    emptyTitle: 'Brak aktywności',
    description: 'Historia generowania, akceptacji i publikacji będzie widoczna w tym miejscu.',
  },
] as const;

export function MarketingCenterPage() {
  return (
    <div>
      <PageHeader
        icon={Megaphone}
        title="Marketing"
        subtitle="Jedno miejsce do planowania treści, automatyzacji email i mierzenia wyników."
      />

      <div className="grid gap-6 xl:grid-cols-2">
        {centerSections.map(section => (
          <Card
            key={section.title}
            className="flex min-h-64 flex-col"
            header={(
              <div className="flex items-center gap-3">
                <section.icon className="h-5 w-5 text-accent-primary" aria-hidden="true" />
                <h2 className="text-lg font-semibold text-text-primary">{section.title}</h2>
              </div>
            )}
          >
            <EmptyState
              icon={section.icon}
              title={section.emptyTitle}
              description={section.description}
              size="sm"
              fillHeight
            />
          </Card>
        ))}
      </div>
    </div>
  );
}
